import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vShow as _vShow, vModelRadio as _vModelRadio, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "scf-sheet__panel" }
const _hoisted_2 = { class: "scf-sheet__head" }
const _hoisted_3 = { class: "scf-sheet__head-text" }
const _hoisted_4 = { class: "scf-sheet__step" }
const _hoisted_5 = { class: "scf-sheet__title" }
const _hoisted_6 = { class: "scf-sheet__where" }
const _hoisted_7 = {
  class: "scf-sheet__progress",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "scf-sheet__body" }
const _hoisted_9 = { class: "scf-sheet__sec" }
const _hoisted_10 = { class: "scf-field" }
const _hoisted_11 = { class: "scf-field" }
const _hoisted_12 = { class: "scf-field" }
const _hoisted_13 = { class: "scf-field" }
const _hoisted_14 = { class: "scf-field" }
const _hoisted_15 = { class: "scf-field" }
const _hoisted_16 = { class: "scf-addr" }
const _hoisted_17 = { class: "scf-addr__zip" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "scf-field" }
const _hoisted_22 = { class: "scf-field" }
const _hoisted_23 = { class: "scf-box" }
const _hoisted_24 = { class: "scf-fixed" }
const _hoisted_25 = { class: "scf-fixed" }
const _hoisted_26 = { class: "scf-fixed" }
const _hoisted_27 = { class: "scf-field scf-field--row" }
const _hoisted_28 = { class: "scf-box" }
const _hoisted_29 = { class: "scf-check" }
const _hoisted_30 = { class: "scf-check" }
const _hoisted_31 = { class: "scf-check" }
const _hoisted_32 = { class: "scf-check" }
const _hoisted_33 = { class: "scf-sheet__sec" }
const _hoisted_34 = { class: "scf-box" }
const _hoisted_35 = { class: "scf-check" }
const _hoisted_36 = { class: "scf-check" }
const _hoisted_37 = {
  key: 0,
  class: "scf-field scf-field--row"
}
const _hoisted_38 = { class: "scf-box" }
const _hoisted_39 = { class: "scf-check" }
const _hoisted_40 = { class: "scf-check" }
const _hoisted_41 = {
  key: 0,
  class: "scf-field scf-field--row"
}
const _hoisted_42 = { class: "scf-field scf-field--row" }
const _hoisted_43 = {
  key: 0,
  class: "scf-box"
}
const _hoisted_44 = { class: "scf-check" }
const _hoisted_45 = { class: "scf-check" }
const _hoisted_46 = { class: "scf-check" }
const _hoisted_47 = { class: "scf-check" }
const _hoisted_48 = { class: "scf-check" }
const _hoisted_49 = {
  key: 0,
  class: "scf-field"
}
const _hoisted_50 = {
  key: 1,
  class: "scf-box"
}
const _hoisted_51 = { class: "scf-check" }
const _hoisted_52 = { class: "scf-check" }
const _hoisted_53 = { class: "scf-check" }
const _hoisted_54 = { class: "scf-check" }
const _hoisted_55 = { class: "scf-check" }
const _hoisted_56 = {
  key: 0,
  class: "scf-field"
}
const _hoisted_57 = { class: "scf-box" }
const _hoisted_58 = { class: "scf-check" }
const _hoisted_59 = { class: "scf-check" }
const _hoisted_60 = {
  key: 0,
  class: "scf-field"
}
const _hoisted_61 = { class: "scf-field" }
const _hoisted_62 = { class: "scf-sheet__sec" }
const _hoisted_63 = {
  key: 0,
  class: "scf-fixed scf-fixed--pre"
}
const _hoisted_64 = { class: "scf-fixed" }
const _hoisted_65 = { class: "scf-fixed" }
const _hoisted_66 = {
  key: 0,
  class: "scf-fixed"
}
const _hoisted_67 = { class: "scf-sheet__sec" }
const _hoisted_68 = { class: "scf-field scf-field--row" }
const _hoisted_69 = { class: "scf-field scf-field--row" }
const _hoisted_70 = { class: "scf-field" }
const _hoisted_71 = { class: "scf-field" }
const _hoisted_72 = {
  key: 0,
  class: "scf-box"
}
const _hoisted_73 = { class: "scf-check" }
const _hoisted_74 = { class: "scf-check" }
const _hoisted_75 = { class: "scf-check" }
const _hoisted_76 = { class: "scf-check" }
const _hoisted_77 = { class: "scf-check" }
const _hoisted_78 = { class: "scf-check" }
const _hoisted_79 = {
  key: 0,
  class: "scf-field"
}
const _hoisted_80 = {
  key: 1,
  class: "scf-box"
}
const _hoisted_81 = { class: "scf-check" }
const _hoisted_82 = { class: "scf-check" }
const _hoisted_83 = { class: "scf-check" }
const _hoisted_84 = { class: "scf-check" }
const _hoisted_85 = { class: "scf-check" }
const _hoisted_86 = {
  key: 0,
  class: "scf-field"
}
const _hoisted_87 = { class: "scf-field scf-field--row" }
const _hoisted_88 = { class: "scf-field" }
const _hoisted_89 = { class: "scf-field scf-field--row" }
const _hoisted_90 = { class: "scf-sheet__sec" }
const _hoisted_91 = { class: "scf-field" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "scf-field" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { class: "scf-field" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "scf-field" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = { class: "scf-field" }
const _hoisted_100 = ["disabled"]
const _hoisted_101 = { class: "scf-field" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { class: "scf-field" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { class: "scf-field" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "scf-check scf-check--block" }
const _hoisted_108 = { class: "scf-field scf-field--row" }
const _hoisted_109 = { class: "scf-sheet__sec" }
const _hoisted_110 = { class: "scf-sheet__foot" }
const _hoisted_111 = ["disabled"]

import { computed, ref, watch } from 'vue'
import type { ServiceContractForm } from '@/composables/useServiceContractForm'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import SignaturePad from '@/components/contract/SignaturePad.vue'

type StepId = 'party' | 'annex1' | 'annex2' | 'annex3' | 'annex4' | 'sign'


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceContractFormSheet',
  props: {
    open: { type: Boolean },
    form: {},
    initialSection: { default: 'party' }
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props



const { opening: postcodeOpening, searchPostcode } = useDaumPostcode()

async function onSearchAddress() {
  try {
    const result = await searchPostcode()
    if (!result) return
    props.form.zipcode = result.zipcode
    props.form.address = [result.address, result.extra].filter(Boolean).join(' ')
    /* 상세주소는 사용자가 이어서 입력 — 포커스는 상세칸으로 */
  } catch (e) {
    window.alert(e instanceof Error ? e.message : '주소 검색을 열지 못했습니다.')
  }
}

const section = ref<StepId>('party')

const wageOn = computed(() => props.form.wageSelect === 'selected')
const acctOn = computed(() => props.form.acctSelect === 'selected')

function feeLabel(kind: 'wage' | 'acct') {
  const fee = kind === 'wage' ? props.form.wageFee : props.form.acctFee
  const selected = kind === 'wage' ? props.form.wageSelect === 'selected' : props.form.acctSelect === 'selected'
  if (!selected || fee === 'none') return '해당 없음'
  if (fee === 'flat') {
    const amount = kind === 'wage' ? props.form.wageFlat : props.form.acctFlat
    return amount ? `월정액 ${amount}원` : '월정액'
  }
  if (fee === 'headcount') {
    const base = props.form.wageBaseHeadcount
    const extra = props.form.wageExtraPerPerson
    return base || extra ? `인원연동 (기본 ${base || '—'}명, 초과 1명당 ${extra || '—'}원)` : '인원연동'
  }
  if (fee === 'volume') return props.form.acctVolume ? `건수연동 ${props.form.acctVolume}` : '건수연동'
  if (fee === 'custom') {
    const formula = kind === 'wage' ? props.form.wageCustomFormula : props.form.acctCustomFormula
    return formula ? `별도 산식 ${formula}` : '별도 산식'
  }
  return '작성된 내용'
}

const wageFeeLabel = computed(() => feeLabel('wage'))
const acctFeeLabel = computed(() => feeLabel('acct'))


const sections = computed(() => [
  {
    id: 'party' as const,
    title: '기관 정보',
    desc: '본문 「계약 당사자」 표와 서명란, 각 별첨의 「갑」 정보에 공통으로 들어갑니다.',
  },
  {
    id: 'annex1' as const,
    title: '서비스 선택',
    desc: '별첨 1 「서비스 내용·기간」에 들어갑니다.',
  },
  {
    id: 'annex2' as const,
    title: wageOn.value && !acctOn.value
      ? '임금관리 요금'
      : acctOn.value && !wageOn.value
        ? '재무회계 요금'
        : '이용요금',
    desc: '별첨 2는 이미 작성된 내용입니다. 이 단계에서는 고치지 않습니다.',
  },
  {
    id: 'annex3' as const,
    title: wageOn.value && !acctOn.value
      ? '임금관리 일정'
      : acctOn.value && !wageOn.value
        ? '재무회계 일정'
        : '업무 일정',
    desc: '별첨 3 「업무 일정과 자료 제공」에 들어갑니다.',
  },
  {
    id: 'annex4' as const,
    title: '개인정보 재위탁',
    desc: '별첨 4 하단 「개인정보 재위탁 현황」에 들어갑니다.',
  },
  /* 별첨 5(서비스 종료)는 해지 시점 서류라 입력 단계에서 뺀다 */
  {
    id: 'sign' as const,
    title: '서명',
    desc: '본문과 별첨의 「갑 (서명)」 자리에 들어가고, PDF에도 그대로 표시됩니다.',
  },
])

const stepIndex = computed(() => sections.value.findIndex((s) => s.id === section.value))
const current = computed(() => sections.value[stepIndex.value] || sections.value[0])

watch(
  () => props.open,
  (open) => {
    if (open) {
      section.value = props.initialSection
    }
  },
)

/* 미선택 서비스 정리 규칙은 useServiceContractForm에 있다 (문서 직접 편집과 경로 공유) */

function goNext() {
  const i = stepIndex.value
  if (section.value === 'annex1' && !wageOn.value && !acctOn.value) {
    window.alert('임금관리 또는 재무회계를 선택해 주세요.')
    return
  }
  if (i < sections.value.length - 1) section.value = sections.value[i + 1].id
}

function goPrev() {
  const i = stepIndex.value
  if (i > 0) section.value = sections.value[i - 1].id
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scf-sheet", { 'is-open': __props.open }]),
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "계약 정보 입력"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "scf-sheet__backdrop",
      "aria-label": "닫기",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(stepIndex.value + 1) + " / " + _toDisplayString(sections.value.length), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(current.value.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(current.value.desc), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "scf-sheet__x",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, "닫기")
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (s, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: s.id,
            class: _normalizeClass(["scf-sheet__dot", { 'is-on': i === stepIndex.value, 'is-done': i < stepIndex.value }])
          }, null, 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[84] || (_cache[84] = _createElementVNode("span", { class: "scf-field__label" }, "기관명", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.orgName) = $event)),
              class: "scf-field__input",
              type: "text",
              autocomplete: "organization"
            }, null, 512), [
              [_vModelText, __props.form.orgName]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[85] || (_cache[85] = _createElementVNode("span", { class: "scf-field__label" }, [
              _createTextVNode("기관기호"),
              _createElementVNode("em", { class: "scf-field__where" }, "본문 표 · 별첨 1")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.facilityCode) = $event)),
              class: "scf-field__input",
              type: "text",
              inputmode: "numeric"
            }, null, 512), [
              [_vModelText, __props.form.facilityCode]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[86] || (_cache[86] = _createElementVNode("span", { class: "scf-field__label" }, "법인·사업자명", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.legalName) = $event)),
              class: "scf-field__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.legalName]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[87] || (_cache[87] = _createElementVNode("span", { class: "scf-field__label" }, "대표자", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.form.representative) = $event)),
              class: "scf-field__input",
              type: "text",
              autocomplete: "name"
            }, null, 512), [
              [_vModelText, __props.form.representative]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[88] || (_cache[88] = _createElementVNode("span", { class: "scf-field__label" }, "사업자등록번호", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.form.bizNumber) = $event)),
              class: "scf-field__input",
              type: "text",
              inputmode: "numeric"
            }, null, 512), [
              [_vModelText, __props.form.bizNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[89] || (_cache[89] = _createElementVNode("span", { class: "scf-field__label" }, "소재지", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  value: __props.form.zipcode,
                  class: "scf-field__input",
                  type: "text",
                  readonly: "",
                  placeholder: "우편번호",
                  onClick: onSearchAddress
                }, null, 8, _hoisted_18),
                _createElementVNode("button", {
                  type: "button",
                  class: "scf-addr__btn",
                  disabled: _unref(postcodeOpening),
                  onClick: onSearchAddress
                }, _toDisplayString(_unref(postcodeOpening) ? '여는 중…' : '주소 검색'), 9, _hoisted_19)
              ]),
              _createElementVNode("input", {
                value: __props.form.address,
                class: "scf-field__input",
                type: "text",
                readonly: "",
                placeholder: "주소",
                onClick: onSearchAddress
              }, null, 8, _hoisted_20),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((__props.form.addressDetail) = $event)),
                class: "scf-field__input",
                type: "text",
                maxlength: "80",
                placeholder: "상세주소",
                autocomplete: "address-line2"
              }, null, 512), [
                [_vModelText, __props.form.addressDetail]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[90] || (_cache[90] = _createElementVNode("span", { class: "scf-field__label" }, [
              _createTextVNode("담당자"),
              _createElementVNode("em", { class: "scf-field__where" }, "별첨 1 · 별첨 3 확인란")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((__props.form.contactName) = $event)),
              class: "scf-field__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.contactName]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[91] || (_cache[91] = _createElementVNode("span", { class: "scf-field__label" }, [
              _createTextVNode("이메일"),
              _createElementVNode("em", { class: "scf-field__where" }, "별첨 1")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((__props.form.contactEmail) = $event)),
              class: "scf-field__input",
              type: "email",
              inputmode: "email",
              autocomplete: "email"
            }, null, 512), [
              [_vModelText, __props.form.contactEmail]
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_23, [
            _cache[92] || (_cache[92] = _createElementVNode("legend", null, "을 | 함우리", -1)),
            _cache[93] || (_cache[93] = _createElementVNode("p", { class: "scf-sheet__note" }, "피계약자에게 보여주는 계약서에서는 함우리 정보를 고치지 않습니다.", -1)),
            _createElementVNode("p", _hoisted_24, _toDisplayString(__props.form.partyBLegalName) + " · " + _toDisplayString(__props.form.partyBBizNumber) + " · " + _toDisplayString(__props.form.partyBOwner), 1),
            _createElementVNode("p", _hoisted_25, _toDisplayString(__props.form.partyBAddress), 1),
            _createElementVNode("p", _hoisted_26, [
              _createTextVNode(_toDisplayString(__props.form.partyBPhone), 1),
              (__props.form.partyBOrg)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(__props.form.partyBOrg), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", null, [
              _cache[94] || (_cache[94] = _createElementVNode("span", { class: "scf-field__label" }, [
                _createTextVNode("체결일(년)"),
                _createElementVNode("em", { class: "scf-field__where" }, "본문 서명란")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((__props.form.signedYear) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric",
                placeholder: "2026"
              }, null, 512), [
                [_vModelText, __props.form.signedYear]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[95] || (_cache[95] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((__props.form.signedMonth) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.signedMonth]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[96] || (_cache[96] = _createElementVNode("span", { class: "scf-field__label" }, "일", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((__props.form.signedDay) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.signedDay]
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_28, [
            _cache[101] || (_cache[101] = _createElementVNode("legend", null, "합의된 별첨 (본문 서명란 표시)", -1)),
            _createElementVNode("label", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((__props.form.annexAgreed.a1) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, __props.form.annexAgreed.a1]
              ]),
              _cache[97] || (_cache[97] = _createElementVNode("span", null, "별첨 1", -1))
            ]),
            _createElementVNode("label", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((__props.form.annexAgreed.a2) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, __props.form.annexAgreed.a2]
              ]),
              _cache[98] || (_cache[98] = _createElementVNode("span", null, "별첨 2", -1))
            ]),
            _createElementVNode("label", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((__props.form.annexAgreed.a3) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, __props.form.annexAgreed.a3]
              ]),
              _cache[99] || (_cache[99] = _createElementVNode("span", null, "별첨 3", -1))
            ]),
            _createElementVNode("label", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((__props.form.annexAgreed.a4) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, __props.form.annexAgreed.a4]
              ]),
              _cache[100] || (_cache[100] = _createElementVNode("span", null, "별첨 4", -1))
            ])
          ])
        ], 512), [
          [_vShow, section.value === 'party']
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_33, [
          _createElementVNode("fieldset", _hoisted_34, [
            _cache[106] || (_cache[106] = _createElementVNode("legend", null, "임금관리", -1)),
            _createElementVNode("label", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((__props.form.wageSelect) = $event)),
                type: "radio",
                value: "selected"
              }, null, 512), [
                [_vModelRadio, __props.form.wageSelect]
              ]),
              _cache[102] || (_cache[102] = _createElementVNode("span", null, "선택", -1))
            ]),
            _createElementVNode("label", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((__props.form.wageSelect) = $event)),
                type: "radio",
                value: "unselected"
              }, null, 512), [
                [_vModelRadio, __props.form.wageSelect]
              ]),
              _cache[103] || (_cache[103] = _createElementVNode("span", null, "미선택", -1))
            ]),
            (__props.form.wageSelect === 'selected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", null, [
                    _cache[104] || (_cache[104] = _createElementVNode("span", { class: "scf-field__label" }, "시작연월(년)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((__props.form.wageStartYear) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "2026"
                    }, null, 512), [
                      [_vModelText, __props.form.wageStartYear]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[105] || (_cache[105] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((__props.form.wageStartMonth) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "4"
                    }, null, 512), [
                      [_vModelText, __props.form.wageStartMonth]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("fieldset", _hoisted_38, [
            _cache[111] || (_cache[111] = _createElementVNode("legend", null, "재무회계", -1)),
            _createElementVNode("label", _hoisted_39, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((__props.form.acctSelect) = $event)),
                type: "radio",
                value: "selected"
              }, null, 512), [
                [_vModelRadio, __props.form.acctSelect]
              ]),
              _cache[107] || (_cache[107] = _createElementVNode("span", null, "선택", -1))
            ]),
            _createElementVNode("label", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((__props.form.acctSelect) = $event)),
                type: "radio",
                value: "unselected"
              }, null, 512), [
                [_vModelRadio, __props.form.acctSelect]
              ]),
              _cache[108] || (_cache[108] = _createElementVNode("span", null, "미선택", -1))
            ]),
            (__props.form.acctSelect === 'selected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", null, [
                    _cache[109] || (_cache[109] = _createElementVNode("span", { class: "scf-field__label" }, "시작연월(년)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((__props.form.acctStartYear) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "2026"
                    }, null, 512), [
                      [_vModelText, __props.form.acctStartYear]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[110] || (_cache[110] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((__props.form.acctStartMonth) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "4"
                    }, null, 512), [
                      [_vModelText, __props.form.acctStartMonth]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", null, [
              _cache[112] || (_cache[112] = _createElementVNode("span", { class: "scf-field__label" }, "공통 계약 최초 종료연월(년)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((__props.form.contractEndYear) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.contractEndYear]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[113] || (_cache[113] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((__props.form.contractEndMonth) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.contractEndMonth]
              ])
            ])
          ]),
          (__props.form.wageSelect === 'selected')
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_43, [
                _cache[120] || (_cache[120] = _createElementVNode("legend", null, "임금관리 업무", -1)),
                _createElementVNode("label", _hoisted_44, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((__props.form.wageScopes.baseInput) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.wageScopes.baseInput]
                  ]),
                  _cache[114] || (_cache[114] = _createElementVNode("span", null, "급여기초자료 입력·정리", -1))
                ]),
                _createElementVNode("label", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((__props.form.wageScopes.payroll) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.wageScopes.payroll]
                  ]),
                  _cache[115] || (_cache[115] = _createElementVNode("span", null, "임금 자동산출·급여대장", -1))
                ]),
                _createElementVNode("label", _hoisted_46, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((__props.form.wageScopes.payslip) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.wageScopes.payslip]
                  ]),
                  _cache[116] || (_cache[116] = _createElementVNode("span", null, "급여명세서 작성 지원", -1))
                ]),
                _createElementVNode("label", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((__props.form.wageScopes.insurance) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.wageScopes.insurance]
                  ]),
                  _cache[117] || (_cache[117] = _createElementVNode("span", null, "사회보험·세무 관련 기초자료", -1))
                ]),
                _createElementVNode("label", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((__props.form.wageScopes.other) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.wageScopes.other]
                  ]),
                  _cache[118] || (_cache[118] = _createElementVNode("span", null, "기타", -1))
                ]),
                (__props.form.wageScopes.other)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _cache[119] || (_cache[119] = _createElementVNode("span", { class: "scf-field__label" }, "기타 내용", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((__props.form.wageScopes.otherText) = $event)),
                        class: "scf-field__input",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, __props.form.wageScopes.otherText]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.form.acctSelect === 'selected')
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_50, [
                _cache[127] || (_cache[127] = _createElementVNode("legend", null, "재무회계 업무", -1)),
                _createElementVNode("label", _hoisted_51, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((__props.form.acctScopes.incomeExpense) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.acctScopes.incomeExpense]
                  ]),
                  _cache[121] || (_cache[121] = _createElementVNode("span", null, "수입·지출자료 정리", -1))
                ]),
                _createElementVNode("label", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((__props.form.acctScopes.voucher) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.acctScopes.voucher]
                  ]),
                  _cache[122] || (_cache[122] = _createElementVNode("span", null, "계정과목 분류·전표입력 지원", -1))
                ]),
                _createElementVNode("label", _hoisted_53, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((__props.form.acctScopes.books) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.acctScopes.books]
                  ]),
                  _cache[123] || (_cache[123] = _createElementVNode("span", null, "월별 장부·관리자료", -1))
                ]),
                _createElementVNode("label", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((__props.form.acctScopes.budget) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.acctScopes.budget]
                  ]),
                  _cache[124] || (_cache[124] = _createElementVNode("span", null, "예산·결산 기초자료", -1))
                ]),
                _createElementVNode("label", _hoisted_55, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((__props.form.acctScopes.other) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, __props.form.acctScopes.other]
                  ]),
                  _cache[125] || (_cache[125] = _createElementVNode("span", null, "기타", -1))
                ]),
                (__props.form.acctScopes.other)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _cache[126] || (_cache[126] = _createElementVNode("span", { class: "scf-field__label" }, "기타 내용", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((__props.form.acctScopes.otherText) = $event)),
                        class: "scf-field__input",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, __props.form.acctScopes.otherText]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("fieldset", _hoisted_57, [
            _cache[131] || (_cache[131] = _createElementVNode("legend", null, "별도 전문자격자 수행", -1)),
            _createElementVNode("label", _hoisted_58, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((__props.form.specialist) = $event)),
                type: "radio",
                value: "none"
              }, null, 512), [
                [_vModelRadio, __props.form.specialist]
              ]),
              _cache[128] || (_cache[128] = _createElementVNode("span", null, "없음", -1))
            ]),
            _createElementVNode("label", _hoisted_59, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((__props.form.specialist) = $event)),
                type: "radio",
                value: "yes"
              }, null, 512), [
                [_vModelRadio, __props.form.specialist]
              ]),
              _cache[129] || (_cache[129] = _createElementVNode("span", null, "있음", -1))
            ]),
            (__props.form.specialist === 'yes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _cache[130] || (_cache[130] = _createElementVNode("span", { class: "scf-field__label" }, "별도 계약 주체·업무명", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((__props.form.specialistDetail) = $event)),
                    class: "scf-field__input",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, __props.form.specialistDetail]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _cache[132] || (_cache[132] = _createElementVNode("span", { class: "scf-field__label" }, "추가업무(소급정리·현장방문 등)", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((__props.form.extraWork) = $event)),
              class: "scf-field__input scf-field__input--area",
              rows: "2"
            }, null, 512), [
              [_vModelText, __props.form.extraWork]
            ])
          ])
        ], 512), [
          [_vShow, section.value === 'annex1']
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_62, [
          _cache[133] || (_cache[133] = _createElementVNode("p", { class: "scf-sheet__note" }, "별첨 2는 계약서를 보여 주기 전에 작성한 내용입니다. 여기서는 고치지 않습니다.", -1)),
          (__props.form.annex2Mode === 'text')
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(__props.form.annex2Text || '적힌 내용이 없습니다.'), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", _hoisted_64, "임금관리 " + _toDisplayString(wageFeeLabel.value), 1),
                _createElementVNode("p", _hoisted_65, "재무회계 " + _toDisplayString(acctFeeLabel.value), 1),
                (__props.form.monthlyTotal)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_66, "월 이용료 합계 " + _toDisplayString(__props.form.monthlyTotal) + "원", 1))
                  : _createCommentVNode("", true)
              ], 64))
        ], 512), [
          [_vShow, section.value === 'annex2']
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_67, [
          (wageOn.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[137] || (_cache[137] = _createElementVNode("p", { class: "scf-sheet__sub" }, "임금관리", -1)),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", null, [
                    _cache[134] || (_cache[134] = _createElementVNode("span", { class: "scf-field__label" }, "급여 기초자료 제출일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((__props.form.wageSubmitDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "5"
                    }, null, 512), [
                      [_vModelText, __props.form.wageSubmitDay]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[135] || (_cache[135] = _createElementVNode("span", { class: "scf-field__label" }, "대장·명세서 제공일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((__props.form.wageProvideDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "10"
                    }, null, 512), [
                      [_vModelText, __props.form.wageProvideDay]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[136] || (_cache[136] = _createElementVNode("span", { class: "scf-field__label" }, "최종 확인일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((__props.form.wageConfirmDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "12"
                    }, null, 512), [
                      [_vModelText, __props.form.wageConfirmDay]
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (acctOn.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[141] || (_cache[141] = _createElementVNode("p", { class: "scf-sheet__sub" }, "재무회계", -1)),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", null, [
                    _cache[138] || (_cache[138] = _createElementVNode("span", { class: "scf-field__label" }, "전월 증빙 제출일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((__props.form.acctSubmitDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.acctSubmitDay]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[139] || (_cache[139] = _createElementVNode("span", { class: "scf-field__label" }, "장부·전표 정리일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((__props.form.acctProvideDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.acctProvideDay]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[140] || (_cache[140] = _createElementVNode("span", { class: "scf-field__label" }, "확인일(매월)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((__props.form.acctConfirmDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.acctConfirmDay]
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (wageOn.value || acctOn.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[142] || (_cache[142] = _createElementVNode("span", { class: "scf-field__label" }, "자료 전달 수단", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((__props.form.deliveryMethod) = $event)),
                    class: "scf-field__input",
                    type: "text",
                    placeholder: "예: 시스템 / 보안 파일공유 / 기타"
                  }, null, 512), [
                    [_vModelText, __props.form.deliveryMethod]
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _cache[143] || (_cache[143] = _createElementVNode("span", { class: "scf-field__label" }, "장애 시 대체 연락처", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((__props.form.backupContact) = $event)),
                    class: "scf-field__input",
                    type: "text",
                    inputmode: "tel"
                  }, null, 512), [
                    [_vModelText, __props.form.backupContact]
                  ])
                ]),
                (wageOn.value)
                  ? (_openBlock(), _createElementBlock("fieldset", _hoisted_72, [
                      _cache[151] || (_cache[151] = _createElementVNode("legend", null, "갑이 제공하는 자료 — 임금관리 선택 시", -1)),
                      _createElementVNode("label", _hoisted_73, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((__props.form.wageDocs.contract) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.contract]
                        ]),
                        _cache[144] || (_cache[144] = _createElementVNode("span", null, "근로계약·임금조건", -1))
                      ]),
                      _createElementVNode("label", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((__props.form.wageDocs.attendance) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.attendance]
                        ]),
                        _cache[145] || (_cache[145] = _createElementVNode("span", null, "근무표·근태", -1))
                      ]),
                      _createElementVNode("label", _hoisted_75, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((__props.form.wageDocs.hr) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.hr]
                        ]),
                        _cache[146] || (_cache[146] = _createElementVNode("span", null, "입사·퇴사·휴직정보", -1))
                      ]),
                      _createElementVNode("label", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((__props.form.wageDocs.allowance) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.allowance]
                        ]),
                        _cache[147] || (_cache[147] = _createElementVNode("span", null, "수당·공제항목", -1))
                      ]),
                      _createElementVNode("label", _hoisted_77, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((__props.form.wageDocs.account) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.account]
                        ]),
                        _cache[148] || (_cache[148] = _createElementVNode("span", null, "지급·계좌변경", -1))
                      ]),
                      _createElementVNode("label", _hoisted_78, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((__props.form.wageDocs.other) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.wageDocs.other]
                        ]),
                        _cache[149] || (_cache[149] = _createElementVNode("span", null, "기타", -1))
                      ]),
                      (__props.form.wageDocs.other)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _cache[150] || (_cache[150] = _createElementVNode("span", { class: "scf-field__label" }, "기타 자료", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((__props.form.wageDocs.otherText) = $event)),
                              class: "scf-field__input",
                              type: "text"
                            }, null, 512), [
                              [_vModelText, __props.form.wageDocs.otherText]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (acctOn.value)
                  ? (_openBlock(), _createElementBlock("fieldset", _hoisted_80, [
                      _cache[158] || (_cache[158] = _createElementVNode("legend", null, "갑이 제공하는 자료 — 재무회계 선택 시", -1)),
                      _createElementVNode("label", _hoisted_81, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((__props.form.acctDocs.transactions) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.acctDocs.transactions]
                        ]),
                        _cache[152] || (_cache[152] = _createElementVNode("span", null, "거래내역", -1))
                      ]),
                      _createElementVNode("label", _hoisted_82, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((__props.form.acctDocs.evidence) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.acctDocs.evidence]
                        ]),
                        _cache[153] || (_cache[153] = _createElementVNode("span", null, "수입·지출 증빙", -1))
                      ]),
                      _createElementVNode("label", _hoisted_83, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((__props.form.acctDocs.subsidy) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.acctDocs.subsidy]
                        ]),
                        _cache[154] || (_cache[154] = _createElementVNode("span", null, "보조금·장기요양급여 관련 내역", -1))
                      ]),
                      _createElementVNode("label", _hoisted_84, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((__props.form.acctDocs.prevBooks) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.acctDocs.prevBooks]
                        ]),
                        _cache[155] || (_cache[155] = _createElementVNode("span", null, "전월 장부", -1))
                      ]),
                      _createElementVNode("label", _hoisted_85, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((__props.form.acctDocs.other) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, __props.form.acctDocs.other]
                        ]),
                        _cache[156] || (_cache[156] = _createElementVNode("span", null, "기타", -1))
                      ]),
                      (__props.form.acctDocs.other)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _cache[157] || (_cache[157] = _createElementVNode("span", { class: "scf-field__label" }, "기타 자료", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((__props.form.acctDocs.otherText) = $event)),
                              class: "scf-field__input",
                              type: "text"
                            }, null, 512), [
                              [_vModelText, __props.form.acctDocs.otherText]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", null, [
                    _cache[159] || (_cache[159] = _createElementVNode("span", { class: "scf-field__label" }, "처리오류 발견 시 통지 경로", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((__props.form.errorNotifyPath) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      placeholder: "예: 담당자 이메일"
                    }, null, 512), [
                      [_vModelText, __props.form.errorNotifyPath]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[160] || (_cache[160] = _createElementVNode("span", { class: "scf-field__label" }, "1차 회신 목표(영업일)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((__props.form.replyBusinessDays) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "3"
                    }, null, 512), [
                      [_vModelText, __props.form.replyBusinessDays]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _cache[161] || (_cache[161] = _createElementVNode("span", { class: "scf-field__label" }, "을 담당자(함우리)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((__props.form.annex3PartyB) = $event)),
                    class: "scf-field__input",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, __props.form.annex3PartyB]
                  ])
                ]),
                _cache[165] || (_cache[165] = _createElementVNode("p", { class: "scf-sheet__note" }, " 별첨 3 확인란의 「갑 담당자」에는 1단계에서 입력한 담당자가 그대로 표시됩니다. ", -1)),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", null, [
                    _cache[162] || (_cache[162] = _createElementVNode("span", { class: "scf-field__label" }, "확인일(년)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((__props.form.annex3ConfirmYear) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.annex3ConfirmYear]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[163] || (_cache[163] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((__props.form.annex3ConfirmMonth) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.annex3ConfirmMonth]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[164] || (_cache[164] = _createElementVNode("span", { class: "scf-field__label" }, "일", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((__props.form.annex3ConfirmDay) = $event)),
                      class: "scf-field__input",
                      type: "text",
                      inputmode: "numeric"
                    }, null, 512), [
                      [_vModelText, __props.form.annex3ConfirmDay]
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, section.value === 'annex3']
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_90, [
          _cache[178] || (_cache[178] = _createElementVNode("p", { class: "scf-sheet__sub" }, "재위탁 업체 ①", -1)),
          _createElementVNode("div", _hoisted_91, [
            _cache[166] || (_cache[166] = _createElementVNode("span", { class: "scf-field__label" }, "업체명", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((__props.form.reconsign1.vendor) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_92), [
              [_vModelText, __props.form.reconsign1.vendor]
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _cache[167] || (_cache[167] = _createElementVNode("span", { class: "scf-field__label" }, "업무", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((__props.form.reconsign1.work) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_94), [
              [_vModelText, __props.form.reconsign1.work]
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _cache[168] || (_cache[168] = _createElementVNode("span", { class: "scf-field__label" }, "처리항목", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((__props.form.reconsign1.items) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_96), [
              [_vModelText, __props.form.reconsign1.items]
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _cache[169] || (_cache[169] = _createElementVNode("span", { class: "scf-field__label" }, "갑 동의일", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((__props.form.reconsign1.agreedDate) = $event)),
              class: "scf-field__input",
              type: "text",
              placeholder: "예: 2026. 1. 15.",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_98), [
              [_vModelText, __props.form.reconsign1.agreedDate]
            ])
          ]),
          _cache[179] || (_cache[179] = _createElementVNode("p", { class: "scf-sheet__sub" }, "재위탁 업체 ② (해당 시)", -1)),
          _createElementVNode("div", _hoisted_99, [
            _cache[170] || (_cache[170] = _createElementVNode("span", { class: "scf-field__label" }, "업체명", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((__props.form.reconsign2.vendor) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_100), [
              [_vModelText, __props.form.reconsign2.vendor]
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _cache[171] || (_cache[171] = _createElementVNode("span", { class: "scf-field__label" }, "업무", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((__props.form.reconsign2.work) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_102), [
              [_vModelText, __props.form.reconsign2.work]
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _cache[172] || (_cache[172] = _createElementVNode("span", { class: "scf-field__label" }, "처리항목", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((__props.form.reconsign2.items) = $event)),
              class: "scf-field__input",
              type: "text",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_104), [
              [_vModelText, __props.form.reconsign2.items]
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _cache[173] || (_cache[173] = _createElementVNode("span", { class: "scf-field__label" }, "갑 동의일", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((__props.form.reconsign2.agreedDate) = $event)),
              class: "scf-field__input",
              type: "text",
              placeholder: "예: 2026. 1. 15.",
              disabled: __props.form.reconsignNone
            }, null, 8, _hoisted_106), [
              [_vModelText, __props.form.reconsign2.agreedDate]
            ])
          ]),
          _createElementVNode("label", _hoisted_107, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((__props.form.reconsignNone) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, __props.form.reconsignNone]
            ]),
            _cache[174] || (_cache[174] = _createElementVNode("span", null, "재위탁이 없는 경우 — 해당 없음", -1))
          ]),
          _cache[180] || (_cache[180] = _createElementVNode("p", { class: "scf-sheet__note" }, " 「해당 없음」에 체크하면 ①·②는 빈칸으로 두고, 별첨 4에 「해당 없음」으로 표시됩니다. 공란은 재위탁 동의로 간주되지 않습니다. ", -1)),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", null, [
              _cache[175] || (_cache[175] = _createElementVNode("span", { class: "scf-field__label" }, "합의일(년)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((__props.form.annex4AgreedYear) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.annex4AgreedYear]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[176] || (_cache[176] = _createElementVNode("span", { class: "scf-field__label" }, "월", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((__props.form.annex4AgreedMonth) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.annex4AgreedMonth]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[177] || (_cache[177] = _createElementVNode("span", { class: "scf-field__label" }, "일", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((__props.form.annex4AgreedDay) = $event)),
                class: "scf-field__input",
                type: "text",
                inputmode: "numeric"
              }, null, 512), [
                [_vModelText, __props.form.annex4AgreedDay]
              ])
            ])
          ])
        ], 512), [
          [_vShow, section.value === 'annex4']
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_109, [
          _cache[181] || (_cache[181] = _createElementVNode("p", { class: "scf-sheet__sub" }, "갑 전자서명", -1)),
          _createVNode(SignaturePad, {
            modelValue: __props.form.partyASignImage,
            "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((__props.form.partyASignImage) = $event))
          }, null, 8, ["modelValue"]),
          _cache[182] || (_cache[182] = _createElementVNode("p", { class: "scf-sheet__note" }, " 여기에 서명하면 계약서 본문과 별첨의 「갑 (서명)」 자리에 서명이 표시되고, PDF에도 그대로 들어갑니다. 서명 옆 성명은 1단계에서 입력한 「대표자」가 표시됩니다. ", -1))
        ], 512), [
          [_vShow, section.value === 'sign']
        ])
      ]),
      _createElementVNode("footer", _hoisted_110, [
        _createElementVNode("button", {
          type: "button",
          class: "scf-sheet__ghost",
          disabled: stepIndex.value === 0,
          onClick: goPrev
        }, "이전", 8, _hoisted_111),
        (stepIndex.value < sections.value.length - 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "scf-sheet__primary",
              onClick: goNext
            }, " 다음 "))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "scf-sheet__primary",
              onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.$emit('close')))
            }, " 완료 "))
      ])
    ])
  ], 2))
}
}

})